export const telegramSaveFileModalName = 'telegram-save-file';
